// extracted by mini-css-extract-plugin
module.exports = {"root":"ResultList_root__3vCEA","resultStatistic":"ResultList_resultStatistic__2vKWh"};